"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ControlToggleSet;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

var _excluded = ["label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ControlToggleSet(_ref) {
  var id = _ref.id,
      options = _ref.options,
      _onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? false : _ref$optional,
      validationError = _ref.validationError,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      _ref$themeToggleGroup = _ref.themeToggleGroup,
      themeToggleGroup = _ref$themeToggleGroup === void 0 ? 'border border--gray-light py3 px3' : _ref$themeToggleGroup,
      _ref$themeToggleConta = _ref.themeToggleContainer,
      themeToggleContainer = _ref$themeToggleConta === void 0 ? '' : _ref$themeToggleConta,
      _ref$themeToggle = _ref.themeToggle,
      themeToggle = _ref$themeToggle === void 0 ? 'txt-s py0 round-full toggle--s toggle--gray' : _ref$themeToggle,
      themeControlWrapper = _ref.themeControlWrapper;
  var groupProps = {
    id: id,
    className: "toggle-group round-full ".concat(themeToggleGroup),
    role: 'radiogroup',
    'aria-required': optional ? false : true,
    'data-testid': "".concat(id, "-input")
  };

  if (validationError) {
    groupProps['aria-invalid'] = true;
  }

  var renderOptions = function renderOptions(_ref2, index) {
    var label = _ref2.label,
        d = _objectWithoutProperties(_ref2, _excluded);

    var extraProps = (0, _omit.default)(d, ['value', 'label']);
    return /*#__PURE__*/_react.default.createElement("label", {
      key: d.value,
      className: "toggle-container ".concat(themeToggleContainer)
    }, /*#__PURE__*/_react.default.createElement("input", _extends({
      value: d.value,
      checked: d.value === value,
      autoFocus: autoFocus && d.value === value,
      onChange: function onChange(e) {
        return _onChange(e.target.value, id);
      },
      name: id,
      type: "radio",
      "data-testid": "".concat(id, "-").concat(index, "-input")
    }, extraProps)), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(themeToggle, " toggle")
    }, label));
  };

  return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
    themeControlWrapper: themeControlWrapper,
    id: id,
    validationError: validationError
  }, /*#__PURE__*/_react.default.createElement("div", groupProps, options.map(renderOptions)));
}

ControlToggleSet.propTypes = {
  /** Identifying value for input element. */
  id: _propTypes.default.string.isRequired,

  /** Function that's called when text changes in the input element. Argument that's returned the id prop and value entered. */
  onChange: _propTypes.default.func.isRequired,

  /** An array of objects containing `label` `value` key value pairings to represent each option. Any additional keys are passed as props to the input. */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node.isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired,

  /** input value */
  value: _propTypes.default.string,

  /** If provided, aria-required=true is added to the control element. */
  optional: _propTypes.default.bool,

  /** Add auto focus attributes. */
  autoFocus: _propTypes.default.bool,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /** Assembly classes to apply to the toggle group */
  themeToggleGroup: _propTypes.default.string,

  /** Assembly classes to apply to the toggle container */
  themeToggleContainer: _propTypes.default.string,

  /** Assembly classes to apply to the toggle element */
  themeToggle: _propTypes.default.string,

  /** Assembly classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string
};